const CSV_HEADERS = [
    'location_code',
    'location_status',
    'result_type',
    'product_name',
    'product_sku',
    'system_quantity',
    'counted_quantity',
    'match',
    'operator_name',
    'reviewer_name',
    'review_outcome',
]

export const escapeField = (value, isBoolean = false) => {
    if (value == null) return ''
    if (isBoolean) return value ? 'yes' : 'no'
    const str = String(value)
    if (str.includes(',') || str.includes('"') || str.includes('\n')) {
        return '"' + str.replace(/"/g, '""') + '"'
    }
    return str
}

const buildResultRow = (location, result, resultType, operatorName) => {
    return [
        escapeField(location.location_code || location.unique_code),
        escapeField(location.status),
        escapeField(resultType),
        escapeField(result.product_name),
        escapeField(result.product_sku),
        escapeField(result.system_quantity),
        escapeField(result.counted_quantity),
        escapeField(result.match, true),
        escapeField(operatorName),
        escapeField(location.reviewer?.full_name),
        escapeField(location.review_outcome),
    ].join(',')
}

const buildEmptyRow = (location, operatorName) => {
    return [
        escapeField(location.location_code || location.unique_code),
        escapeField(location.status),
        '', '', '', '', '', '',
        escapeField(operatorName),
        escapeField(location.reviewer?.full_name),
        escapeField(location.review_outcome),
    ].join(',')
}

export const buildCycleCountCsv = (task) => {
    const operatorName = task.operator?.full_name || task.operator?.email || task.operator_name || ''
    const locations = task.locations || []
    const rows = []

    for (const location of locations) {
        const results = location.results || []
        const reviewerResults = location.reviewer_results || []

        if (results.length === 0 && reviewerResults.length === 0) {
            rows.push(buildEmptyRow(location, operatorName))
        } else {
            for (const result of results) {
                rows.push(buildResultRow(location, result, 'counter', operatorName))
            }
            for (const result of reviewerResults) {
                rows.push(buildResultRow(location, result, 'reviewer', operatorName))
            }
        }
    }

    const header = CSV_HEADERS.join(',')
    const body = rows.length > 0 ? '\n' + rows.join('\n') : ''
    return '\uFEFF' + header + body
}
